import { Injectable } from "@angular/core";
import { ApiEndPoint } from "./api-end-point";
import { ApiResultError } from "..";
var OrganizationEndPoints = /** @class */ (function () {
    function OrganizationEndPoints(apiEndPoint) {
        this.apiEndPoint = apiEndPoint;
    }
    OrganizationEndPoints.prototype.load = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.post('organization/getOrgInfo', { token: token }).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    OrganizationEndPoints.prototype.loadDetails = function (uri) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.apiEndPoint.get('customerportal/organizationDetails', false, true, 'uri=' + uri).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    OrganizationEndPoints.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    OrganizationEndPoints.ctorParameters = function () { return [
        { type: ApiEndPoint, },
    ]; };
    return OrganizationEndPoints;
}());
export { OrganizationEndPoints };
//# sourceMappingURL=organization-end-points.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/endpoints/organization-end-points.js
// module id = 361
// module chunks = 14